import { toast, Slide } from 'react-toastify'
import { stopProcessingApprovalRequest, resetProcessingApprovalRequest } from '../../actions/approvalRequests'
import {
  STATUS_APPROVED,
  STATUS_DENIED,
  STATUS_NEEDS_INFO,
  ETS_STATUS
} from '../../constants/ApprovalRequestConstants'
import { Fade } from '../../components/common'
import ApprovalRequestsNavTabs from '../../components/approvals/ApprovalRequestsNavTabs'

const mapStateToProps = state => {
  const { processApprovalRequest } = state
  return { processApprovalRequest }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  stopProcessingApprovalRequest,
  resetProcessingApprovalRequest
}, dispatch)

class ApprovalRequestsPage extends Component {
  componentDidUpdate(prevProps) {
    const { processApprovalRequest: { submitted, approvalHistory: { etsApprovalStatus }}} = this.props

    if (prevProps.submitted !== submitted && submitted) {
      switch (etsApprovalStatus) {
        case STATUS_APPROVED:
          this.requestUpdated('success')
          break

        case STATUS_DENIED:
          this.requestUpdated('error')
          break

        case STATUS_NEEDS_INFO:
          this.requestUpdated('warn')
          break

        default:
          this.requestUpdated('info')
      }
    }
  }

  async requestUpdated(updateType) {
    const {
      processApprovalRequest: { approvalHistory: { etsApprovalStatus }},
      stopProcessingApprovalRequest,
      resetProcessingApprovalRequest
    } = this.props

    toast[updateType](`Request marked as ${ETS_STATUS[etsApprovalStatus]}`, {
      position: toast.POSITION.BOTTOM_LEFT,
      autoClose: 10000,
      transition: Slide
    })
    await stopProcessingApprovalRequest()
    await resetProcessingApprovalRequest()
  }

  render() {
    return (
      <Fade>
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h1>Approval Requests</h1>
            </div>
            <div className="col-xs-12">
              <ApprovalRequestsNavTabs />
            </div>
          </div>
        </div>
      </Fade>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalRequestsPage)
